import React from 'react';
import { Outlet } from 'react-router';

import { DevOnlyRoute } from '@/backoffice/app/dev-only-route/dev-only-route';
import { TCustomRouteObject } from '@/shared/types/router.types';

// DevOnlyRoute gates on its `children` prop, so nested routes need an
// Outlet inside it rather than passing it as the route Component directly.
const FeatureFlagCatalogGuard: React.FC = () => (
  <DevOnlyRoute>
    <Outlet />
  </DevOnlyRoute>
);

// No `permission` gate -- gated instead by the `custom:isDeveloper` Cognito
// attribute via DevOnlyRoute, which is also what the back-office enforces.
export const featureFlagCatalogRoutes: TCustomRouteObject = {
  path: 'feature-flag-catalog',
  Component: FeatureFlagCatalogGuard,
  handle: {
    crumb: {
      label: 'feature_flag_catalog',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      // Lazy so the flag inventory never lands in the eagerly-loaded bundle.
      lazy: async () => {
        const { FeatureFlagCatalogRoute } =
          await import('./feature-flag-catalog');
        return { Component: FeatureFlagCatalogRoute };
      },
    },
  ],
};
